// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createVerticalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import { specificationsStyles } from "@guestsupply/Overrides/Widgets/ProductDetails/ProductDetailsSpecifications";
import { color, hideElementOnPrint, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

specificationsStyles.specificationsAccordion = {
    headingLevel: 1,
    css: css`
        margin-top: 52px;
        @media print {
            page-break-inside: avoid;
        }
    `,
};

specificationsStyles.specificationsAccordionSection = {
    headerProps: {
        css: css`
            margin-bottom: 8px;
            button,
            button:focus {
                padding: 0 0 12px;
                border-top: none !important;
                border-bottom: 1px solid ${color("common.border")} !important;
                align-items: center;
            }

            @media print {
                button {
                    display: block !important;
                }
            }
        `,
    },
    toggleIconProps: {
        size: 21,
        css: css`
            &${IconWrapper}, svg {
                width: 15px;
                height: 21px;
                @media print {
                    display: none;
                }
            }
        `,
    },
    titleTypographyProps: {
        variant: "h3",
        size: 24,
        weight: "bold",
        css: css`
            line-height: 30px;
            margin-bottom: 0;
        `,
    },
    panelProps: {
        css: css`
            margin-bottom: 24px;
            margin-top: 0;
            padding-left: 0;
            > p {
                font-size: 14px;
            }
            ul {
                margin: 0;
                padding-left: 16px;
                li {
                    margin: 0;
                    &:not(:last-child) {
                        margin-bottom: 8px;
                    }
                }
            }
        `,
    },
    toggleTransition: {
        positionerCss: css`
            ${hideElementOnPrint}
        `,
    },
};
specificationsStyles.attributeSectionWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px 22px;
        ${xScreen("lte", "md")} {
            gap: 16px;
        }
    `,
};
specificationsStyles.labelValueWrapper = {
    ...createVerticalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                width: auto;
                min-width: 232px;
                ${xScreen("lte", "md")} {
                    min-width: 156px;
                }
                ${xScreen("lte", "sm")} {
                    width: calc(50% - 8px);
                    min-width: unset;
                }
            `,
        },
        heading: {
            weight: "bold",
            size: 14,
            css: css`
                line-height: 16px;
                &:after {
                    content: ":";
                }
            `,
        },
        text: {
            weight: 400,
            size: 14,
            css: css`
                line-height: 21px;
            `,
        },
    }),
};
specificationsStyles.documentsWrapper = {
    css: css`
        margin: 0;
        padding-left: 16px;
    `,
};
specificationsStyles.documentItem = {
    css: css`
        margin: 0;
        line-height: 16px;
        &:not(:last-child) {
            margin-bottom: 8px;
        }
    `,
};
specificationsStyles.documentNameText = {
    css: css`
        line-height: 16px;
        display: inherit;
    `,
};
specificationsStyles.attributeTypeWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: auto;
        min-width: 232px;
        ${xScreen("lte", "md")} {
            min-width: 156px;
        }
        ${xScreen("lte", "sm")} {
            width: calc(50% - 8px);
            min-width: unset;
        }
    `,
};
specificationsStyles.brandLink = {
    color: "text.main",
    typographyProps: {
        weight: 400,
        size: 14,
        lineHeight: "21px",
    },
};
